import { type ApexOptions } from 'apexcharts';
import { Fragment, useEffect, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { type ICourseReport } from 'src/models';
import { type ReportType } from 'src/store/Courses/actions';
import { type RootState } from 'src/store';
import { useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
import useStyles from './CourseChart-styles';

interface Props {
	type: ReportType;
}

function CourseChart({ type }: Props) {
	const classes = useStyles();
	const data = useSelector(
		(state: RootState) => state.courses.reports[type].data,
	);
	const [options, setOptions] = useState<ApexOptions>({
		chart: {
			height: 350,
			type: 'bar',
		},
		dataLabels: {
			enabled: false,
		},
		fill: {
			opacity: 1,
		},
		plotOptions: {
			bar: {
				columnWidth: '55%',
				horizontal: false,
			},
		},
		series: [
			{
				data: data.map((courseReport: ICourseReport) =>
					parseInt(courseReport.registeredUsers?.toString() || '0'),
				),
				name: 'Registrados',
			},
			{
				data: data.map((courseReport: ICourseReport) =>
					parseInt(courseReport.finishedUsers?.toString() || '0'),
				),
				name: 'Terminados',
			},
			{
				data: data.map((courseReport: ICourseReport) =>
					parseInt(courseReport.passedUsers?.toString() || '0'),
				),
				name: 'Pasados',
			},
		],
		stroke: {
			colors: ['transparent'],
			show: true,
			width: 2,
		},
		xaxis: {
			categories: data.map(
				(courseReport: ICourseReport) => courseReport.name,
			),
		},
		yaxis: {
			labels: {
				formatter: (val: number, opts?: any) =>
					val.toString().replace('.0', ''),
			},
			title: {
				style: {
					fontWeight: 500,
				},
				text: 'Usuarios',
			},
		},
	});

	useEffect(() => {
		setOptions({
			...options,
			series: [
				{
					data: data.map((courseReport: ICourseReport) =>
						parseInt(
							courseReport.registeredUsers?.toString() || '0',
						),
					),
					name: 'Registrados',
				},
				{
					data: data.map((courseReport: ICourseReport) =>
						parseInt(courseReport.finishedUsers?.toString() || '0'),
					),
					name: 'Terminados',
				},
				{
					data: data.map((courseReport: ICourseReport) =>
						parseInt(courseReport.passedUsers?.toString() || '0'),
					),
					name: 'Aprobaron',
				},
			],
			xaxis: {
				categories: data.map(
					(courseReport: ICourseReport) => courseReport.name,
				),
			},
		});
	}, [data]);

	return data.length > 0 ? (
		<Grid container>
			<Grid item xs={12}>
				<Typography className={classes.title}>
					{' '}
					Usuarios por curso{' '}
				</Typography>
			</Grid>

			<Grid item style={{ marginTop: 16 }} xs={12}>
				<ReactApexChart
					height={'300'}
					options={options}
					series={options.series}
					type={'bar'}
				/>
			</Grid>
		</Grid>
	) : (
		<Fragment />
	);
}

export default CourseChart;
